import Container    from '../../../components/Theme/Dashboard';

const Home=(props)=>{
  return  <Container>
            PROYECTOS
          </Container>
}
export default Home
